<template>
  <v-container>
    <ClinicDoctors v-if="clinicId" :clinic-id="clinicId" />
    <v-alert v-else type="warning" outlined> No clinic selected </v-alert>
  </v-container>
</template>

<script>
import ClinicDoctors from '@/components/ClinicProfile/ClinicDoctors';
import { mapGetters } from 'vuex';

export default {
  name: 'Doctors',
  components: {
    ClinicDoctors,
  },
  computed: {
    ...mapGetters('auth', ['clinicId', 'isClinicStaff']),
  },
};
</script>
